<script lang="ts">
	import type { Device } from 'src/types/Device';
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { status_configurator } from 'src/helpers/device_data_helpers';
	import { useNavigateToHistoryStatisticsTab } from 'src/components/Sidepanel/useNavigateToHistoryStatisticsTab';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import LastReporterV2 from 'src/components/Drawer/LastReporterV2.svelte';
	import WeatherStationDevice from 'src/components/WeatherStation/WeatherStationDevice.svelte';
	import { devices_config } from '@devices/index';

	export let device: Device;

	const { navigateToHistoryStatisticsTab } = useNavigateToHistoryStatisticsTab();

	const handleOnClickThumbChart = () => {
		navigateToHistoryStatisticsTab();
	};

	$: deviceConfig = devices_config?.[device?.type];

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: _statuses =
		status?.online && deviceConfig ? (status_configurator(status, device, settings) as any[]) : [];
</script>

<DeviceViewStateWrapper {device}>
	<div slot="content">
		<WeatherStationDevice
			{device}
			statuses={_statuses}
			on:openChart={handleOnClickThumbChart}
			usedInSidepanel
		/>
	</div>

	<div class="flex-full-height justify-content-end" slot="staticBottom">
		{#if !device.shared}
			<LastReporterV2 class="mb-s" {device} />
		{/if}
	</div>
</DeviceViewStateWrapper>
